export enum RoutePathMatch {
    LOGIN = 'login',
    REGISTER = 'registro',
    PROFILE = 'perfil',
    CREATE_PROFILE = 'crear-perfil',
    REGISTER_PROFILE = 'registro/perfil',
    REGISTER_PERSON = 'registro/persona',
    REGISTER_COMPANY = 'registro/empresa',
    REGISTER_COMPANY_PROFILE = 'registro/empresa-perfil',
    REGISTER_COMPANY_PERSON = 'registro/empresa-persona',
    REGISTER_DATA = 'registro/persona-datos',
    OPERATIONS = 'operaciones',
    RECOVER_PASSWORD = 'recuperar-contraseña',
    RECOVER_PASSWORD_NEW_PASSWORD = 'recuperar-contraseña/nueva-contraseña',
    CHANGE = 'cambio',
    CARDS = 'tarjetas',
    CHANGE_TRANSFER = 'cambio/transferencia',
    CHANGE_VERIFY = 'cambio/verificacion',
    HOME = 'home',
    HOME_CHANGE_TRANSFER = '/home/cambio/transferencia',
    HOME_CHANGE_VERIFY = '/home/cambio/verificacion',
    HOME_CHANGE_FORM = '/home/cambio/formulario',
    HOME_OPERATIONS = '/home/operaciones',
    HOME_CHANGE = '/home/cambio',
    HOME_ACCOUNTS = '/home/cuentas',
    HOME_CARDS = '/home/tarjetas',
    HOME_PROFILE = '/home/perfil',
    ACCOUNTS = 'cuentas'
}
